export default __webpack_public_path__ + "device_stick_up_cam_plug-in_v2.99311d0a.png";